<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <div class="row">
            <div class="col-xl-7 col-md-7 col-xs-12 col-sm-12 mt-1">
                <router-link to="/lead/new" class="btn btn-info"><i class="fa fa-plus"></i> Adicionar
                    lead</router-link>
            </div>
            <div class="col-xl-2 col-md-2 col-xs-12 col-sm-12 offset-xl-3 offset-md-3  mt-1 ">
                <div class="wrapper input-group">

                    <button class="btn btn-light ml-2 " @click="advancedSearch()"><i class="fa fa-align-justify"></i>
                        Busca avançada</button>
                </div>
            </div>
        </div>
        <div class="row mt-3" v-show="advanced_search">
            <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                <fieldset>
                    <div class="row">
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Nome</label>
                            <input type="text" id="description" class="form-control" placeholder="Ex: Empresa XYZ"
                                v-model="advanced_search_input.name">
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">E-mail</label>
                            <input type="text" id="description" class="form-control"
                                placeholder="Ex: usuario@dominio.com" v-model="advanced_search_input.email">
                        </div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Leads inseridos a partir de</label>
                            <input type="date" id="from" class="form-control"
                               v-model="advanced_search_input.from">
                        </div>
                        <div class="col-xl-6 col-md-6 col-xs-12 col-sm-12">
                            <label for="">Leads inseridos até</label>
                            <input type="date" id="to" class="form-control" v-model="advanced_search_input.to">
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-xl-12 col-md-12 col-xs-12 col-sm-12">
                            <button class="btn btn-info" @click="executeAdvancedSearch()"> <i
                                    class="fas fa-search fa-sm"></i> Pesquisar</button>
                            <button class="btn btn-danger ml-2" @click="cleanAdvancedSearch()"> <i
                                    class="fas fa-times fa-sm"></i> Limpar</button>
                        </div>

                    </div>
                </fieldset>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                        <h6 class="m-0 font-weight-bold text-primary">Leads
                            <br><small><span
                                    v-if="total_itens > 0">Total registros encontrados: {{ formatDecimal(total_itens) }}</span></small>
                        </h6> <button class="btn btn-warning btn-sm"
                            @click="loadData()"><i class="fa fa-undo"></i> Recarregar
                            dados</button>
                    </div>
                    <div class="card-body" :class="leads.length <=0? 'card-body-no-spaccing':''">
                        <div class="table-responsive">
                            <table class="table" id="dataTable" width="100%" cellspacing="0">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>E-mail</th>
                                        <th>Telefone</th>
                                        <th>Status</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(lead) in leads" :key="lead.id">
                                        <td>{{ lead.name }} </td>
                                        <td>{{ lead.email }} </td>
                                        <td>{{ lead.phone_formatted }} </td>
                                        <td v-if="lead.status == 'Pendente'"> <span class="badge badge-warning">Pendente</span></td>
                                        <td v-else-if="lead.status == 'Ativo'"> <span class="badge badge-success">Ativo</span></td>
                                        <td v-else> <span class="badge badge-danger">{{ lead.status }}</span></td>
                                        <td>
                                            <div class="dropdown">
                                                <button class="btn btn-primary dropdown-toggle" type="button"
                                                    id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true"
                                                    aria-expanded="false">
                                                    Ações
                                                </button>
                                                <div class="dropdown-menu animated--fade-in"
                                                    aria-labelledby="dropdownMenuButton">
                                                    <router-link class="dropdown-item" :to="{
                                                        name: 'lead_edit',
                                                        params: { id: lead.id }
                                                    }">Detalhes</router-link>
                                                    <button class="dropdown-item"
                                                        @click="updateStatus(lead.id, 'Ativo')"
                                                        v-if="lead.status == 'Pendente'">Ativar lead </button>
                                                    <button class="dropdown-item"
                                                        @click="updateStatus(lead.id, 'Desistente')"
                                                        v-if="lead.status == 'Pendente'">Desistir do lead</button>
                                                    <button class="dropdown-item"
                                                        @click="deletelead(lead.id)">Excluir</button>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr v-if="leads.length > 0 && page > 1">
                                        <td colspan="6" class="align-middle text-center pt-5"> <button
                                                @click="loadData()" class="btn btn-info btn-sm"
                                                :disabled="!buttonPagination"><i class="fa fa-spinner"></i> Carregar
                                                mais registros</button></td>
                                    </tr>
                                    <tr v-show="leads.length <= 0">
                                        <td colspan="6" class="text-center">Nenhum registro encontrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

export default {
    components: { Loading },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            advanced_search: false,
            advanced_search_input: {},
            leads: [],
            url_api: '',
            page: 1,
            last_page: 1,
            total_itens: 0
        }
    },
    computed: {
        buttonPagination: function () {
            return this.page > 1;
        }
    },
    methods: {
        onCancel() { },
        advancedSearch() {
            this.advanced_search = !this.advanced_search
        },
        closeAdvancedSearch() {
            this.advanced_search = false
        },
        executeAdvancedSearch() {
            this.page = 1;
            this.leads = {};
            this.loadData();
        },
        cleanAdvancedSearch() {
            this.leads = {}
            this.advanced_search_input = {}
            this.loadData();
        },

        formatDecimal(number) {
           return new Intl.NumberFormat().format(number)
        },

        loadData() {
            this.isLoading = true;

            api.get('/lead', {
                params: {
                    'name': this.advanced_search_input.name,
                    'email': this.advanced_search_input.email,
                    'from': this.advanced_search_input.from,
                    'to': this.advanced_search_input.to,
                    'page': this.page
                }
            })
                .then((response) => {
                    this.isLoading = false;
                    this.total_itens = response.data.total_itens;
                    this.last_page = response.data.last_page;
                    if (this.page <= 1) {
                        this.leads = response.data.data;
                    } else {
                        this.leads = this.leads.concat(response.data.data);
                    }

                    if (this.page < response.data.last_page) {
                        this.page++;
                    } else {
                        this.page = 1;
                    }

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status);
                })
        },

        deletelead(id) {
            this.$confirm(
                {
                    message: 'Deseja apagar o lead?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.delete('/lead/' + id)
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Lead excluído com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        },

        updateStatus(id, status) {
            this.$confirm(
                {
                    message: 'Deseja alterar o status para ' + status.toLocaleLowerCase() + '?',
                    button: {
                        no: 'Não',
                        yes: 'Sim'
                    },

                    callback: confirm => {
                        if (confirm) {
                            this.isLoading = true;
                            api.post('/lead/' + id + '/status', {  'status': status } )
                                .then(() => {
                                    this.isLoading = false;
                                    this.$notify({
                                        title: "Sucesso",
                                        text: "Status com sucesso",
                                        type: 'success'
                                    });
                                    this.page = 1;
                                    this.loadData();
                                }).catch(error => {
                                    this.isLoading = false;
                                    handleRequestErrors(error.status);
                                })
                        }
                    }
                }
            )
        }

    },
    mounted() {
        this.url_api = process.env.VUE_APP_URL_API
        this.loadData();

    },
}
</script>

<style></style>